import { Action } from '@ngrx/store';
import { IRpaConnectionBluePrism } from 'app/rpa-bots/core/IRpaBots';

export enum EBluePrismConnActions {
  BluePrismConnList = '[BluePrism Connectors] List of connectors from BluePrism',
  BluePrismConnListSuccess = '[BluePrism Connectors] List of connectors from BluePrism Success',
  getCurrentBluePrismConn = '[BluePrism Connectors] Set the selected connector from list',
  getCurrentBluePrismConnSuccess = '[BluePrism Connectors] Set the selected connector from server',
  UpdateBluePrismConn = '[BluePrism Connectors] Update selected BluePrism connector',
  UpdateBluePrismConnSuccess = '[BluePrism Connectors] Update selected BluePrism connector Success',
  ShowSuccessToast = '[BluePrism Connectors] Show Success toast from update action',
  ResetBluePrismState = '[BluePrism Connectors] Reset blue prism state',
  TestBluePrismConn = '[BluePrism Connectors] Test connection selected BluePrism',
  TestBluePrismConnSuccess = '[BluePrism Connectors] Test connection selected BluePrism Success',
}

export class BluePrismConnList implements Action {
  public readonly type = EBluePrismConnActions.BluePrismConnList;
}

export class BluePrismConnListSuccess implements Action {
  public readonly type = EBluePrismConnActions.BluePrismConnListSuccess;
  constructor(public payload: IRpaConnectionBluePrism[]) { }
}

export class getCurrentBluePrismConn implements Action {
  public readonly type = EBluePrismConnActions.getCurrentBluePrismConn;
  constructor(public payload: string) { } // payload is the id of connector
}

export class getCurrentBluePrismConnSuccess implements Action {
  public readonly type = EBluePrismConnActions.getCurrentBluePrismConnSuccess;
  constructor(public payload: IRpaConnectionBluePrism) { }
}

export class UpdateBluePrismConn implements Action {
  public readonly type = EBluePrismConnActions.UpdateBluePrismConn;
  constructor(public payload: IRpaConnectionBluePrism) { }
}

export class UpdateBluePrismConnSuccess implements Action {
  public readonly type = EBluePrismConnActions.UpdateBluePrismConnSuccess;
}

export class ResetBluePrismState implements Action {
  public readonly type = EBluePrismConnActions.ResetBluePrismState;
}

export class ShowSuccessToast implements Action {
  public readonly type = EBluePrismConnActions.ShowSuccessToast;
  constructor() { }
}

export class TestBluePrismConn implements Action {
  public readonly type = EBluePrismConnActions.TestBluePrismConn;
  constructor(public payload: IRpaConnectionBluePrism) { }
}

export class TestBluePrismConnSuccess implements Action {
  public readonly type = EBluePrismConnActions.TestBluePrismConnSuccess;
  constructor() { }
}

export type BluePrismConnActions =
  | BluePrismConnList
  | BluePrismConnListSuccess
  | getCurrentBluePrismConn
  | getCurrentBluePrismConnSuccess
  | UpdateBluePrismConn
  | UpdateBluePrismConnSuccess
  | ShowSuccessToast
  | ResetBluePrismState
  | TestBluePrismConn
  | TestBluePrismConnSuccess;
